<script lang="ts">
  import Vue from "vue";
  import CodeMirrorEditorComponent from "../../components/formulas/code-mirror-editor.vue";
  // tslint:disable-next-line:no-submodule-imports
  import "codemirror/addon/hint/show-hint.js";
  import Initialable from "../../mixins/initialable";
  import MentionMixin from "../../mixins/codeMirror/mentionMixin";
  import CodeMirror from "codemirror/lib/codemirror"
  import {ICursorPosition} from "~/helpers/codeMirrorWidget";
  import {IOrganization} from "~/interfaces/formSubmissionEditInterfaces"
  import Form from "@/formability/form_builder/models/form";

  export default Vue.extend({
    extends: CodeMirrorEditorComponent,
    mixins: [MentionMixin, Initialable],
    props: {
      expandsUp: {
        type: Boolean,
        default: false
      },
      organization: {
        type: Object as () => Pick<IOrganization, 'id'>,
        required: false,
      },
      applicationId: {
        type: String,
        default: ""
      }
    },
    data: function() {
      return {
        editorMinHeight: 100,
        editorMaxHeight: 300,
      }
    },
    created() {
      Object.assign(this.defaultConfig, this.noteConfig)
    },
    mounted() {
      this.$nextTick(() => {
        this.addMentionKeyListener()
        if (this.expandsUp) {
          this.addTextAreaExpandsUpListener()
        }
      })
    },
    computed: {
      noteConfig() {
        const organizationId = this.organization?.id || this.selectedOrganization?.id
        return {
          lineWrapping: true,
          hintOptions: {
            hint: this.customHintFunction,
            closeCharacters: /[()\[\]{};:>,.]/,
            completeSingle: false,
            className: 'dropdown-menu',
            organizationId,
            applicationId: this.applicationId
          },
        }
      }
    },
    methods: {
      addMentionKeyListener(): void {
        this.editor.codeMirror.on('keydown', (cm, event) => {
          const to: ICursorPosition = cm.getCursor()
          const from: ICursorPosition = CodeMirror.Pos(to.line, to.ch - 1)
          const prevChar = cm.getRange(from, to)
          // do not fire if char before '@' is a word character, e.g. when typing an email
          if (event.key === '@' && !(/\w/.test(prevChar))) {
            cm.execCommand('autocomplete')
          }
        });
      },
      addTextAreaExpandsUpListener() {
        $(document).on('createNote:clear', (e) => {
          this.$emit('update:note-height', `${this.editorMinHeight + 10}px`)
        });
        this.editor.codeMirror.on('changes', (cm, event) => {
          const wrapperEl = cm.getWrapperElement()
          const scrollArea = wrapperEl.querySelector('.CodeMirror-scroll')
          const codeArea = scrollArea.querySelector('.CodeMirror-sizer')

          // handle expansion
          if (codeArea.clientHeight > scrollArea.clientHeight) {
            if (codeArea.clientHeight < this.editorMaxHeight) {
              wrapperEl.style.height = `${codeArea.clientHeight + 10}px`
              this.$emit('update:note-height', wrapperEl.style.height)
            }
          }

          // handle shrinkage
          if (codeArea.clientHeight < scrollArea.clientHeight) {
            if (scrollArea.clientHeight > this.editorMinHeight) {
              wrapperEl.style.height = `${Math.max(codeArea.clientHeight + 10, this.editorMinHeight)}px`
              this.$emit('update:note-height', wrapperEl.style.height)
            }
          }
        })
      }
    },
  });
</script>